function Empty(props) {
  return Object.keys(props).length === 0;
}

export default Empty;
